import { Page } from '@app/routes';
import { moonPhaseOneBg, moonPhaseTwoBg } from '@app/assets';
import { LOCAL_STORAGE, ONE_DAY_MS } from '@app/shared/constants/common';

export const COGNITION_DAILY_BANNERS = [
  {
    route: Page.DAILY_ENERGY,
    tKeyTitle: 'daily_energy_description.energy_of_the_day',
    tKeyDescription: 'cognition.daily_energy_description',
    imgSrc: moonPhaseOneBg,
    cooldownKey: null,
    cooldown: null,
  },
  {
    route: Page.DAILY_CARD_DESCRIPTION,
    tKeyTitle: 'cognition.magic_card_title',
    tKeyDescription: 'cognition.magic_card_description',
    imgSrc: moonPhaseTwoBg,
    cooldownKey: LOCAL_STORAGE.cardDailyUseAt,
    cooldown: ONE_DAY_MS,
  },
];

export const ABILITIES_EMOJIS = [
  '🦸',
  '🙏',
  '️⚡️',
  '',
  '‍❤️',
  '👩‍❤️‍👨',
  '💸',
  '',
  '🦋',
  '🎨',
  '🧘🏻',
  '',
  '',
  '',
  '',
];

export enum DevelopmentSphere {
  PERSONALITY = 'personality',
  MONEY = 'money',
  HEALTH = 'health',
  RELATIONSHIP = 'relationship',
  ART = 'art',
  MISSION = 'mission',
}

export const DEVELOP_BANNERS = [
  {
    number: 1,
    title: DevelopmentSphere.PERSONALITY,
    imgClassName: 'size-[167px] min-w-[167px] -bottom-4 -right-10',
    bannerClassName: 'h-[197px]',
  },
  {
    number: 2,
    title: DevelopmentSphere.MONEY,
    imgClassName: 'size-[201px] min-w-[201px] scale-x-[-1] -right-14 bottom-0',
    bannerClassName: 'h-[241px]',
  },
  {
    number: 3,
    title: DevelopmentSphere.HEALTH,
    imgClassName: 'min-w-[138px] h-[193px] -right-6 -bottom-5',
    bannerClassName: 'h-[240px]',
  },
  {
    number: 4,
    title: DevelopmentSphere.RELATIONSHIP,
    imgClassName: 'min-w-[253px] h-[253px] scale-x-[-1] -right-16 bottom-0',
    bannerClassName: 'h-[278px]',
  },
  {
    number: 5,
    title: DevelopmentSphere.ART,
    imgClassName: 'size-[202px] min-w-[202px] bottom-0 -right-14',
    bannerClassName: 'h-[276px]',
  },
  {
    number: 6,
    title: DevelopmentSphere.MISSION,
    imgClassName: 'min-w-[194px] h-[194px] scale-x-[-1] -right-16 -bottom-6',
    bannerClassName: 'h-[194px]',
  },
];
